import { render, staticRenderFns } from "./RegularAnnouncement.vue?vue&type=template&id=0befbb3c&"
import script from "./RegularAnnouncement.vue?vue&type=script&lang=js&"
export * from "./RegularAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports